import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskCaseNotesEditRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-case-notes-edit',
	path: '/jira/servicedesk/projects/:projectKey/settings/case-management/case-notes/:caseNoteId/edit',
	exact: true,
};
